import React from 'react';

const AccessDenied = () => (
  <div className="general-info-page page-without-secondary-menu page-content-container">
    <div className="general-info-text">Access Denied</div>
  </div>
);

export default AccessDenied;
